import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWG504F1 (銷貨折讓單核准)
// ============================================================

export interface ApprovalCandidate {
  fg140_01: string; // 折讓單號
  fg140_11: string; // 折讓日期
  fg140_12: string; // 公司名稱
  fg140_14: string; // 折讓淨額
  fg140_15: string; // 折讓稅額
  fg140_80: boolean; // 核准旗標
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwg504Api = {
  /** Query allowance order candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwg504/candidates', { params });
    return res.data;
  },

  /**
   * Execute batch approval for selected allowance orders.
   * PWG504-VAL-APPROVE-CONFIRM-DIALOG (human_approved 2026-07-23): backend
   * now rejects any call missing an explicit confirmed:true with 422 + zero
   * DB mutation. Callers must only invoke this after the user has confirmed
   * (e.g. inside a Modal.confirm's onOk), same as pwh508f1/pwh5m8f1's own
   * frontend API clients.
   */
  async approve(items: string[], confirmed: boolean = true): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwg504/approve', { items, confirmed });
    return res.data;
  },
};
